export default __webpack_public_path__ + "src/images/packages/maison-de-plage/b11efb62730cbdaae588582bcea2c520-2.jpg";